export const BUTTON_SIZES = ['sm', 'md', 'lg'] as const;
export const DEFAULT_BUTTON_SIZE: ButtonSize = 'md';

export const isButtonSize = (value: unknown): value is ButtonSize =>
  (BUTTON_SIZES as ReadonlyArray<unknown>).includes(value);

export type ButtonSize = (typeof BUTTON_SIZES)[number];
